<script setup lang="ts">
const props = defineProps({
  onClose: {
    type: Function as PropType<() => void | Promise<void>>,
    required: false,
    default: undefined,
  },
  onSaved: {
    type: Function as PropType<() => void | Promise<void>>,
    required: false,
    default: undefined,
  },
});

const close = async () => {
  if (props.onClose) {
    await props.onClose();
  }
};

const saved = async () => {
  if (props.onSaved) {
    await props.onSaved();
    return;
  }

  await close();
};
</script>

<template>
  <CompanionCreateSubmissionCurriculumPicker
    :on-cancel="close"
    :on-saved="saved"
  />
</template>
